import { render } from "./ConversationsBaseLayout.vue?vue&type=template&id=94862c0c"
import script from "./ConversationsBaseLayout.vue?vue&type=script&lang=js"
export * from "./ConversationsBaseLayout.vue?vue&type=script&lang=js"
script.render = render

export default script